import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface MobileResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function updateMobileAction(
  uuid: string,
  { ...payload }: { mobile: string; countryId: string }
): Promise<ApiResponse<MobileResponse>> {
  return api.put<ApiResponse<MobileResponse>>(`/users/${uuid}/update-mobile`, {
    mobile: payload.mobile,
    country_id: payload.countryId,
  })
}

export function verifyMobileAction(uuid: string): Promise<ApiResponse<MobileResponse>> {
  return api.put<ApiResponse<MobileResponse>>(`/users/${uuid}/verify-mobile`)
}

export function rejectMobileAction(uuid: string): Promise<ApiResponse<MobileResponse>> {
  return api.put<ApiResponse<MobileResponse>>(`/users/${uuid}/reject-mobile`)
}
